var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "avatar-editor" }, [
    _c("div", { staticClass: "avatar-editor-header" }, [
      _c("div", { staticClass: "avatar-editor-title" }, [
        _vm.portrait && _vm.portrait.cutUrl
          ? _c("h3", [
              _vm._v("\n        " + _vm._s(_vm.$t("editPhoto")) + "\n      "),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("i", { staticClass: "isif isif-close" })]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "avatar-editor-body" }, [
      _vm.portrait && _vm.portrait.cutUrl
        ? _c(
            "div",
            { staticClass: "full por" },
            [
              _c("ICropper", {
                ref: "ICropper",
                attrs: {
                  boundary: _vm.cropperOptions.boundary,
                  viewport: _vm.cropperOptions.viewport,
                  "mouse-wheel-zoom": false,
                  "show-zoomer": _vm.cropperOptions.showZoomer,
                },
                on: { cropperReady: _vm.cropperReady },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "cropper-slider-wrapper" }, [
                _c("span", { staticClass: "cropper-percent" }, [
                  _vm._v(_vm._s(_vm.cropperZoom)),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cropperZoom,
                      expression: "cropperZoom",
                    },
                  ],
                  ref: "cropperZoom",
                  staticClass: "cropper-slider",
                  attrs: { type: "range", min: "0", max: _vm.maxZoom },
                  domProps: { value: _vm.cropperZoom },
                  on: {
                    __r: function ($event) {
                      _vm.cropperZoom = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "cropper-percent" }, [
                  _vm._v(_vm._s(_vm.maxZoom)),
                ]),
              ]),
            ],
            1
          )
        : _c("div", { staticClass: "upload-container" }, [
            _c(
              "button",
              {
                staticClass: "upload-image-btn",
                on: { click: _vm.triggerImageInput },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("uploadImage")) + "\n      "
                ),
              ]
            ),
          ]),
    ]),
    _vm._v(" "),
    _vm.portrait && _vm.portrait.cutUrl
      ? _c("div", { staticClass: "avatar-editor-footer" }, [
          _c(
            "button",
            {
              staticClass: "delete-image-btn",
              on: { click: _vm.onDeleteImage },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("deletePhoto")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "change-image-btn",
              on: { click: _vm.triggerImageInput },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("changePhoto")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "upload-image-btn", on: { click: _vm.onSaveImage } },
            [_vm._v("\n      " + _vm._s(_vm.$t("savePhoto")) + "\n    ")]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      ref: "imageInput",
      attrs: { id: "avatar-file", type: "file" },
      on: { change: _vm.onChangeImage },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }